//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'page-left-right-layout',
    methods:{
      handleclick(val){
        console.log(val);
      }
    }
};



// WEBPACK FOOTER //
// ./example/pages/layout-left-right.vue